module.exports = __webpack_public_path__ + "img/album18_16.6604a5c4.jpg";